// extracted by mini-css-extract-plugin
export default {"melodyVideo":"KK-z","isFullWidth":"LK-z","landingPageVideo":"MK-z","play":"NK-z","iframeVideo":"OK-z","playHidden":"PK-z","fullwidth":"QK-z"};